const SchedularDate = (date) => {
  if (date) {
    const formatted =
      date.getFullYear() +
      "-" +
      String(date.getMonth() + 1).padStart(2, "0") +
      "-" +
      String(date.getDate()).padStart(2, "0");
    return formatted;
  }
  return date
};

export default SchedularDate;
